import React, { useEffect, useState, useContext } from "react";
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../../App.js";
import TotalSuppliers from "../TotalSuppliers/TotalSuppliers";
import RiskPriority from "../RiskPriority/RiskPriority";
import OnboardingStatus from "../OnboardingStatus/OnboardingStatus";

import CompanyService from "../../../core/service/CompanyService";
import Utils from "../../../core/utilities/Utils.js";

function SupplierListingCards({ t }) {
  const { glbRegulation, setGlbRegulation, glbRegulations } =
    useContext(RegulationContext);
  const [data, setData] = useState([]);
  const [totalSupplier, setTotalSupplier] = useState("");
  const [onBoardStatus, setOnBoardStatus] = useState([]);
  const [riskPriority, setRiskPriority] = useState([]);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  useEffect(() => {
    getCount();
    getRiskPriority();
  }, [glbRegulation]);

  const getCount = () => {
    CompanyService.getSuppliersCount()
      .then((response) => {
        setTotalSupplier(response.data.totalSuppliers);
        setOnBoardStatus(response.data.onboardStatus);
      })
      .catch((error) => {
        console.log("err", error);
      });
  };
  const getRiskPriority = () => {
    var data = JSON.parse(localStorage.getItem("authority"));
    const company = data.profile.company.id;
    if (glbRegulation.id) {
      CompanyService.getSuppliersCountByRegulation(
        company,
        glbRegulation?.id,
        Utils.recentDate
      )
        .then((response) => {
          setRiskPriority(response.data);
        })
        .catch((error) => {
          console.log("err", error);
        });
    }
  };

  const isEmptyObject =(obj) => {
    return Object.keys(obj).length === 0;
}

  return (
    <>
      <TotalSuppliers totalSupplier={totalSupplier} />
      {glbRegulation.type == 'R' && <RiskPriority riskPriority={riskPriority} />}
      {!isEmptyObject(onBoardStatus) && <OnboardingStatus onBoardStatus={onBoardStatus} />}
    </>
  );
}

export default withTranslation()(SupplierListingCards);
